import store from 'store';
import _get from 'lodash/get';
import _isEqual from 'lodash/isEqual';
import localStore from 'store';
import * as CryptoJS from 'crypto-js';
import { base64url } from './base64url';

type BoardFieldsTypes = 'assigned_only' | 'block_risk' | 'is_default' | 'view';

export class PermissionsHelper {

  private permissions = store.get('common_settings') || {};

  public can(group: any | string[], action: string | Array<string>, value: any = true): boolean {
    if (!this.permissions) {
      return false;
    }

    if (!Array.isArray(group)) {
      group = [group];
    }

    const checkPermission = (permissions: string): boolean => {
      const setting = _get(this.permissions, [...group, permissions, 'value'], null);

      return _isEqual(setting, value);
    };

    if (Array.isArray(action)) {
      return action.some(checkPermission);
    }

    return checkPermission(action);
  }

  public get(group: any | string[], action: string, value: 'value' | 'additional_data' = 'value'): any {
    if (!this.permissions) {
      return false;
    }

    if (!Array.isArray(group)) {
      group = [group];
    }

    return  _get(this.permissions, [...group, action, value], null);
  }

  public roleGeneral(action: string | Array<string>): boolean {
    const checkPermission = (permissions: string): boolean => _get(this.permissions, ['role', 'role_general_permissions', permissions], false);

    if (Array.isArray(action)) {
      return action.some(checkPermission);
    }

    return checkPermission(action);
  }

  public roleSettings(action: string, useValueKey = false): any {
    if (useValueKey) {
      return _get(this.permissions, ['role', 'role_settings', action, 'value'], null);
    }

    return _get(this.permissions, ['role', 'role_settings', action, 'additional_data'], null);
  }

  public boardSettings(entity: string, value: BoardFieldsTypes): any {
    return _get(this.permissions, ['role', 'role_board_permissions', entity, value], false);
  }

  /* 
    _get will handle 3 permission values:
      true:   can view and can edit
      false:  can only view
      null:   not exist in permissions at all, meaning cannot view and cannot edit
  */
  public fieldSettings(entity: string, field: string, value?: boolean | null): boolean | null {
    if (!value) {
      return _get(this.permissions, ['role', 'role_field_permissions', entity, field], null);
    }

    return _get(this.permissions, ['role', 'role_field_permissions', entity, field, value], null);
  }

  public getJWT(entityType: 'applications' | 'leads' | 'opportunities' | 'partials' | 'refunds' | 'tickets' | 'calendar' | 'referrals'): string {
    const fieldsRaw = localStore.get(`${entityType}_model_info`) || [];
    const user = localStore.get(`user`) || {};

    let fields = [];
    for (const key in fieldsRaw) {
      fields.push(fieldsRaw[key].name);
    }

    let type;
    if (entityType === "leads") {
      type = "assigned_to";
    } else if (entityType === "applications") {
      type = "assigned_user_crm_id";
    }

    const value = this.boardSettings(entityType, "assigned_only");
    const view = this.boardSettings(entityType, "view");

    const header = {
      alg: "HS256",
      typ: "JWT",
    };
    const data = {
      fields,
      permissions: {
        onlyAssigned: {
          type,
          value,
        },
        view,
      },
      user: {
        role: user.role,
        crm_id: user.crm_id,
      },
    };
    const key = "BPz5hCcjMYdVw2d3BX3kyY2WX7HVzkHL";

    const stringifiedHeader = CryptoJS.enc.Utf8.parse(JSON.stringify(header));
    const encodedHeader = base64url(stringifiedHeader);

    const stringifiedData = CryptoJS.enc.Utf8.parse(JSON.stringify(data));
    const encodedData = base64url(stringifiedData);

    let signature = CryptoJS.HmacSHA256(`${encodedHeader}.${encodedData}`, key);
    const encodedSignature = base64url(signature);

    const token = `${encodedHeader}.${encodedData}.${encodedSignature}`;

    return token;
  }
}

